import React from "react";
import { Paper, Grid, useTheme } from "@mui/material";
import {
  SolarPower,
  Power,
  WbSunny,
  TrendingUp,
  Speed,
} from "@mui/icons-material";
import ParameterItem from "./ParameterItem";
import SectionHeader from "./SectionHeader";
import { useAuth } from "../../../AuthContext";

const SolarPerformance = ({ sx }) => {
  const { data, pumpStats,isOnline } = useAuth();
  const theme = useTheme();

  return (
    <Paper
      sx={{
        borderRadius: theme.shape.borderRadius * 2,
        overflow: "hidden",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        ...sx,
      }}
    >
      <SectionHeader
        icon={<SolarPower fontSize="small" />}
        title="Solar Performance"
      />

      <Grid
        container
        spacing={1.5}
        sx={{
          p: 2,
          flex: 1,
          alignContent: "flex-start",
        }}
      >
        <ParameterItem
          icon={<Power />}
          name="AC Output Current"
          value={data?.ac_output_current || "--"}
          unit="A"
        />
         {/* <ParameterItem
          icon={<Power />}
          name="I1 Current"
          value={(data.ac_output_current?(data?.ac_output_current /3)?.toFixed(2):'--')}
          unit="A"
        />
         <ParameterItem
          icon={<Power />}
          name="I2 Current"
          value={(data?.ac_output_current /3).toFixed(2)|| "--"}
          unit="A"
        />
         <ParameterItem
          icon={<Power />}
          name="I3 Current"
          value={(data?.ac_output_current /3).toFixed(2) || "--"}
          unit="A"
        /> */}
        <ParameterItem
          icon={<Power />}
          name="AC Output Voltage"
          value={data?.ac_output_voltage || "--"}
          unit="V"
        />
        <ParameterItem
          icon={<WbSunny />}
          name="DC Voltage"
          value={isOnline?data?.dc_voltage:'--' || "--"}
          unit="V"
        />
        <ParameterItem
          icon={<WbSunny />}
          name="DC Current"
          value={isOnline?data?.dc_current:'--' || "--"}
          unit="A"
        />
         <ParameterItem 
                  icon={<Power />} 
                  name="Power" 
                  value={isOnline?data?.power:'--' || "--"} 
                  unit="kW" 
                />
        <ParameterItem
          icon={<TrendingUp />}
          name="Drive Frequency"
          value={data?.drive_frequency || "--"}
          unit="Hz"
        />
        {/* <ParameterItem 
          icon={<Speed />} 
          name="Energy Consumed" 
          value={data?.energy_consumed || '--'} 
          unit="kWh" 
        /> */}
        <ParameterItem
          icon={<Speed />}
          name="Energy from Grid"
          value={(data?.energy_from_grid)?.toFixed(3) || "--"}
          unit="kWh"
        />
        <ParameterItem
          icon={<Speed />}
          name="Today Energy from Solar"
          value={(pumpStats?.pump_aggregates?.energy_from_solar ?? 0).toFixed(3)}
          unit="kWh"
        />
        <ParameterItem
          icon={<Speed />}
          name="Total Energy from Solar"
          value={(pumpStats?.pump_aggregates?.total_solar_energy ?? 0).toFixed(3)}
          unit="kWh"
        />
        {/* <ParameterItem 
          icon={<Speed />} 
          name="Energy Out to grid" 
          value={data?.energy_out_to_grid || '--'} 
          unit="kWh" 
        /> */}



        {/* <Grid item xs={12} sx={{ mt: 'auto' }}>
          <ParameterItem 
            icon={<SolarPower />} 
            name="Solar Generation Chart" 
            value="" 
            sx={{ height: 150 }}
          />
        </Grid> */}
      </Grid>
    </Paper>
  );
};

export default React.memo(SolarPerformance);
